import React from 'react';
import {
    Form, Input, Label, FormGroup, Card, Button, CardBody,
    Modal, ModalHeader, ModalBody, ModalFooter, Progress,  FormText,
} from 'reactstrap';

import NotificationSystem from 'react-notification-system';
 import {connect} from "react-redux";
import {alertActions, commonActions, modalActions} from "../../_actions";
import {alertConstants, appConstants} from "../../_constants";
import {apiActions} from "../../_actions/api.actions";

//Page content util
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
 import SelectCreateableListComponent from "../utils/selectCreatableList";
 import SelectListComponent from "../utils/selectList";
import PageEmptyContent from "../utils/page.empty-content";
 import WorkflowTable from "./workflow-table";
//Icons
import AddIcon from 'react-icons/lib/md/library-add';
import AirportIcon from 'react-icons/lib/md/flight-land';
import {commonService} from "../../_services";
import {appHelpers, store} from "../../_helpers";


const ViewContent = ({children}) => (
    <div className="view-content view-components">
        {children}
    </div>
);

class WorkflowViewContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            workFlows: [],
            workFlowProcess: [],
            modal: false,
            workflowModal: false,
            modalClass: '',
            //  Workflow form
            WorkFlowId: false,
            WorkFlowName: '',
            WorkFlowActions: [],
            ActiveWorkFlowActions: [],
            ProcessId: '',
            //page error
            contentError: false,  //Errors that affect content on the page
            componentError: false,  //Errors generated within the component
            componentErrorMessages: [],  //Errors generated within the component form
            error: false, //Error state mutable via Redux
            success: false, //Success message mutable via Redux

            //    Notification
            notification: {
                // title: 'Default Title',
                message: 'Default Message',
                level: 'success',
                position: 'tr',
                dismissible: true
            },

            //pagination params
            pageSize: 10,
            currentPage: 1,
            totalRecordsCount: 0,
            createWorkflowEntityTypeId: null,
            editWorkflowEntityTypeId: null
        };

        this._notificationSystem = null;
        this._lastNotificationAdded = null;
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        const reduxState = store.getState();
        let { workFlowProcess, entities } = reduxState;
        const { dispatch } = this.props;
        if(workFlowProcess){
            this.setState({ workFlowProcess: workFlowProcess })
        }else{
            this.fetchWorkflowProcess();
        }
        if(!entities){
            dispatch(commonActions.getEntities())
        }else{
            this.setEntityTypes(entities)
        }
        this.fetchWorkFlows();
    }

    componentWillReceiveProps = function (nextProps) {
        const {alert} = nextProps;
        const {modal, entities} = nextProps;

        if (alert) {
            if (alert.type === alertConstants.SUCCESS) {
                // this.setState({error: false, success: alert.message})
                this.setState({error: false, success: 'Operation successful'});
                this.resetForm();
            }
            else if (alert.type === alertConstants.CLEAR) {
                this.setState({success: false, error: false})

            } else {
                this.setState({success: false, error: alert.message})
            }
        }
        if (modal) {
            if (modal.type === appConstants.OPEN_MODAL) {
                this.setState({
                    modal: true,
                    modalClass: modal.modalClass
                });
            } else if (modal.type === appConstants.CLOSE_MODAL) {
                this.setState({
                    modal: false,
                    modalClass: modal.modalClass
                });
                this.resetForm();
            }
        }
        if(entities){
            this.setEntityTypes(entities)
        }
    };

    setEntityTypes = (entities) => {
        let  createWorkflowEntityTypeId;
        let editWorkflowEntityTypeId;

        entities.forEach(entity =>{
            if(entity.EntityType === appConstants.APP_ENTITIES.CREATE_WORKFLOW){
                createWorkflowEntityTypeId = entity.EntityTypeId;
            }
            else if(entity.EntityType === appConstants.APP_ENTITIES.UPDATE_WORKFLOW){
                editWorkflowEntityTypeId = entity.EntityTypeId;
            }
        });
        this.setState({createWorkflowEntityTypeId, editWorkflowEntityTypeId})

    }

    handleChange = (event, attribute) => {
        let currState = this.state;
        currState[attribute] = event.target.value;
        let errorMessages = this.state.componentErrorMessages;
        errorMessages[attribute] = false;
        this.setState(currState);
        this.setState({componentErrorMessages: errorMessages});
    };

    handleSelectChange = (payload, attribute, stateAttribute) => {
        let currState = this.state;
        let errorMessages = this.state.componentErrorMessages;
        errorMessages[stateAttribute] = false;
        currState[stateAttribute] = (payload) ? payload[attribute] : ''; //Cater for setting up data and clearing data
        this.setState(currState);
    };

    handleWorkflowActionsChange = (payload) => {
         let errorMessages = this.state.componentErrorMessages;
        errorMessages['WorkFlowActions'] = false;
        this.setState({WorkFlowActions : payload, componentErrorMessages: errorMessages });
    };

    validateInput = () => {
        let _errs_ = [];
        let formValid = true;
        if(this.state.UserId === ''){
            _errs_['UserId'] = 'Please select user';
            formValid = false;
        }

        if(this.state.ActionType === ''){
            _errs_['ActionType'] = 'Please select action type';
            formValid = false;
        }
        this.setState({componentErrorMessages: _errs_});
        return formValid;
    };

    validateWorkFlowInput = () => {
        let _errs_ = [];
        let formValid = true;
        if(this.state.WorkFlowActions.length === 0){
            _errs_['WorkFlowActions'] = 'Add at least one step';
            formValid = false;
        }

        if(this.state.WorkFlowName === ''){
            _errs_['WorkFlowName'] = 'Please type workflow name';
            formValid = false;
        }

        if(this.state.ProcessId === ''){
            _errs_['ProcessId'] = 'Please select a process';
            formValid = false;
        }
        this.setState({componentErrorMessages: _errs_});
        return formValid;
    };

    notify = (message, level) => {
        let notification = this.state.notification;
        notification['message'] = message;
        notification['level'] = level;
        notification.onRemove = this.onRemove;
        this._lastNotificationAdded = this._notificationSystem.addNotification(notification);
    };

    onRemove = (notification) => {
        if (this._lastNotificationAdded && notification.uid === this._lastNotificationAdded.uid) {
            this._lastNotificationAdded = null;
        }
    };

    resetForm() {
        this.setState({
            componentError: false, componentErrorMessages: [], UserId: '', ActionType: '',
            WorkFlowName: '', ActiveWorkFlowActions: [], WorkFlowActions: [], WorkFlowId: false, ProcessId : ''
        });
        this.resetError();
    }

    handleSubmit  = (event) => {
        event.preventDefault();
        this.setState({isRequesting: true});
        this.resetError();
        if(this.validateInput()){
            this.processSubmit();
        }
    };

    handleSubmitWorkFlow  = (event) => {
        event.preventDefault();
        this.setState({isRequesting: true});
        this.resetError();
        if(this.validateWorkFlowInput()){
            this.processWorkflowSubmit();
        }
    };

    resetError() {
        this.props.dispatch(modalActions.clear());
        this.props.dispatch(alertActions.clear());
    }

    processSubmit = () => {
        let {airportId} = this.state;
        let payload = {
            Name: this.state.Name, Code: this.state.Code,
            CountryCode: this.state.CountryCode,
            IsLocal: this.state.IsLocal
        };
        if (airportId) {
            payload.Id = airportId;
        }
        const {dispatch} = this.props;
        dispatch(apiActions.startRequest());
        dispatch(commonActions.manageAirport(payload))
            .then(res => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.toggle(null, 'modalSlide');
                    let msg = (payload.Id) ? 'Airport edited successfully' : 'Airport created successfully';
                    this.notify(msg, appConstants.NOTIFY_SUCCESS);
                    this.fetchAirports();
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    dispatch(apiActions.endRequest());
                }

            });
    };

    processWorkflowSubmit = () => {
        let { dispatch } = this.props;
        let { WorkFlowActions, WorkFlowName, WorkFlowId, ProcessId, createWorkflowEntityTypeId, editWorkflowEntityTypeId } = this.state;
        let { authentication } = store.getState();

        let workflowActions = [];
        WorkFlowActions.map((item, index) => {
            let action_type = { ActionLevel: (index + 1), Name: item.Name };
            //identify new Actions
            if(item.className === undefined )
                action_type.Id = item.Id;
           return workflowActions.push(action_type);
        } );
        let payload = {
            Name: WorkFlowName,
            WorkFlowActions: workflowActions,
            WorkflowProcessId: ProcessId
        };

        if(WorkFlowId) payload.Id = WorkFlowId;

        let getWorkflowActionsName = [];

        payload.WorkFlowActions.map(item => {
            return getWorkflowActionsName.push(item.Name);
        });

       let  workflowActionsName = getWorkflowActionsName.join(", ");

        let payloadTemplate = {
            Name: WorkFlowName,
            WorkFlowActions: workflowActionsName,
        };

        let makerCheckerPayload = {
            AppId: appConstants.MAKER_CHECKER_APP_ID,
            Payload: JSON.stringify(payload),
            PayloadViewTemplate: JSON.stringify(payloadTemplate),
            URL: `${appConstants.PAS_URL}/api/workflow/save`,
            EntityTypeId: createWorkflowEntityTypeId,
            CreatedBy: authentication.user.userName
        };

        if(WorkFlowId) makerCheckerPayload.EntityTypeId = editWorkflowEntityTypeId;

        dispatch(apiActions.startRequest());
        commonService.createMakerChecker(makerCheckerPayload)
            .then(res => {
                if(res.status === appConstants.SUCCESS_RESPONSE) {
                    this.toggle( 'workflowModal');
                    let msg = (payload.Id) ? 'workflow update sent successfully'  : 'workflow creation sent successfully';
                    this.notify(msg, appConstants.NOTIFY_SUCCESS);
                    dispatch(apiActions.endRequest());
                }
                else if(res.status === appConstants.ERROR_RESPONSE){
                    dispatch(alertActions.error(res.response));
                    dispatch(apiActions.endRequest());
                }
            });
        // commonService.createWorkflow(payload)
         //    .then((res) => {
         //        if (res.status === appConstants.SUCCESS_RESPONSE) {
         //            this.toggle('workflowModal');
         //            dispatch(apiActions.endRequest());
         //            this.notify('Workflow details saved successfully', appConstants.NOTIFY_SUCCESS);
         //            this.fetchWorkFlows();
         //        }
         //        else if (res.status === appConstants.ERROR_RESPONSE) {
         //            dispatch(alertActions.error(res.response));
         //            dispatch(apiActions.endRequest());
         //        }
         //    });
    };

    fetchWorkFlows = (pageNumber) => {
        let { dispatch } = this.props;
        let { pageSize } = this.state;

        let fromIndex;
        if(pageNumber === undefined){
            dispatch(apiActions.startFullPageRequest());
            fromIndex = 0;
            pageNumber = 1;
        }else{
            fromIndex = pageSize * (pageNumber -1);
            dispatch(apiActions.startRequest());

        }
        let payload = {
            "From": fromIndex,
            "PageSize": pageSize,
            "Parameter":{
                "IncludeWorkflowActions": true
            }
        };
        commonService.getWorkFlows(payload)
            .then((res) => {
                 if (res.status === appConstants.SUCCESS_RESPONSE) {
                    const workFlows = res.response.Results;
                    this.setState({workFlows, currentPage: pageNumber, totalRecordsCount : res.response.TotalCount});
                        dispatch(apiActions.endRequest());
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    this.notify('Unable to get work flows', appConstants.NOTIFY_ERROR);
                        dispatch(apiActions.endRequest());
                }
            });
     };
    passWorkflowDetails = (workflow) => {
        this.resetError();
         this.setState({
             ActiveWorkFlowActions: workflow.WorkflowActions,
             workflowModal: true,
             WorkFlowName: workflow.Name,
             WorkFlowId: workflow.Id,
             ProcessId: workflow.WorkflowProcessId
        });

    };
    fetchWorkflowProcess = () => {
        this.setState({contentError: false});
        const {dispatch} = this.props;
        dispatch(commonActions.getWorkflowProcess())
            .then(() => {
                let { workFlowProcess } = this.props;
                workFlowProcess = workFlowProcess.filter(item => item.Status === 1);
                this.setState({workFlowProcess: workFlowProcess });
            }).catch(error => {
            let errorMessage = appHelpers.interpretErrorResponse(error);
            this.notify(errorMessage, appConstants.NOTIFY_ERROR);
            this.setState({contentError: errorMessage});
        });
    };
    toggle = (modal) => {
        let currState = this.state;
        currState[modal] = !currState[modal];
        this.setState(currState);
        if(modal !== 'workflowUserEditModal'){
            this.resetForm();
        }
    };
    renderPageResponse() {
        if(this.state.error){
            return (<div className="alert alert-danger">{this.state.error}</div>);
        }
        else if(this.state.componentError){
            return (<div className="alert alert-danger">{this.state.componentError}</div>);
        }
        else if(this.state.success){
            return (<div className="alert alert-success">{this.state.success}</div>);
        }
    }

    render() {
        let modalResponse = this.renderPageResponse();
        const { requesting } = this.props;
        const { pageRequesting } = this.props;
        const { workFlowProcess, contentError, componentErrorMessages, workFlows, pageSize, currentPage, totalRecordsCount } = this.state;
         let workFlowsLength = workFlows.length;
        return (
            <div className="view">
                <ViewContent>
                    <Card className="mb-4">
                        {/*Progress bar for Pending API Request*/}
                        { ((pageRequesting || requesting) && !pageRequesting ) && <Progress animated striped color="success" value={100} className="mb-2"/> }

                        {/*Display loader when component content is dependent on Data from API*/}
                        { (!contentError && pageRequesting) &&
                        <PageLoading/>
                        }

                        {/*Display error when component fail to get Data from API*/}
                        { contentError &&
                             <PageError error={this.state.contentError }/>
                        }

                        {/*Display component content when Data is gotten from API*/}
                        { (!contentError && !pageRequesting) &&
                             <CardBody className="table-responsive">
                            <div className="row">
                                <h6 className="mb-4 col-md-8 text-uppercase pull-left">Workflow Records
                                    <FormText color="muted">
                                        {
                                            (totalRecordsCount > 0) &&
                                            <div>
                                                <AirportIcon size="18" color="#43a8df"/>&nbsp;
                                                <span>{ totalRecordsCount }&nbsp;
                                                    { (totalRecordsCount === 1) ? 'workflow created' : 'workflows created' }
                                                 </span>
                                            </div>
                                        }
                                    </FormText>
                                    </h6>
                                <div className="mb-4 col-md-4 text-right">
                                    <Button disabled={workFlowProcess.length === 0}  className="btn-avi-primary" onClick={(e) => this.toggle('workflowModal')}>
                                        <AddIcon color="#ffffff" size="18"/>&nbsp;New Workflow
                                     </Button>{" "}
                                </div>
                            </div>
                                 {(!pageRequesting &&  workFlowsLength > 0) &&
                                     <WorkflowTable data={ workFlows } editCallback={this.passWorkflowDetails} totalRecordsCount={totalRecordsCount} currentPage={currentPage} pageSize={pageSize} pageDataCallback={this.fetchWorkFlows}/>
                                 }

                                 {(!pageRequesting && workFlowsLength === 0) &&
                                     <PageEmptyContent message='No workflow yet!'/>
                                 }

                            <Modal isOpen={this.state.workflowModal} toggle={() => this.toggle('workflowModal')} className={this.state.modalClass}>
                                <ModalHeader toggle={() => this.toggle('workflowModal')}>Workflow</ModalHeader>
                                <Form onSubmit={this.handleSubmitWorkFlow}>
                                    <ModalBody>
                                        { modalResponse }
                                        <FormGroup className={"mb-4 " + (this.state.componentErrorMessages.WorkFlowName ? 'has-danger' : '')}>
                                            <Label>Name</Label>
                                            <Input type="text" placeholder="" value={this.state.WorkFlowName} onChange={(event) => this.handleChange(event, 'WorkFlowName')} />
                                            { componentErrorMessages.WorkFlowName && <FormText color="danger"> {componentErrorMessages.WorkFlowName }</FormText> }
                                        </FormGroup>
                                        <FormGroup className={"mb-4 " + (this.state.componentErrorMessages.ProcessId ? 'has-danger' : '')}>
                                            <Label for="selectedWorkFlowProcess">Process </Label>
                                            <SelectListComponent data={this.state.workFlowProcess} placeholder={'Select process...'} valueKey='Id' textField='ProcessName' selectValue={this.state.ProcessId} onValueChange={(payload) => this.handleSelectChange(payload, 'Id', 'ProcessId')} />
                                             { componentErrorMessages.ProcessId && <FormText color="danger"> {componentErrorMessages.ProcessId }</FormText> }
                                        </FormGroup>
                                        <FormGroup className={"mb-4 " + (this.state.componentErrorMessages.WorkFlowActions ? 'has-danger' : '')}>
                                            <Label for="countrySelect">Steps </Label>
                                            <SelectCreateableListComponent multiSelectMode={false} data={this.state.ActiveWorkFlowActions} placeholder={'Type name of step...'} promptText={'Add '} valueKey='Id' textField='Name' selectValue={this.state.WorkFlowActions} onValueChange={(payload) => this.handleWorkflowActionsChange(payload)} />
                                            { componentErrorMessages.WorkFlowActions && <FormText color="danger"> {componentErrorMessages.WorkFlowActions }</FormText> }
                                        </FormGroup>
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button className="btn-avi-primary" disabled={ requesting } > Proceed </Button>{' '}
                                        <Button color="secondary" onClick={() => this.toggle('workflowModal')}>Cancel</Button>
                                    </ModalFooter>
                                </Form>
                                { requesting &&  <div className={'loading-dot active'}></div>}
                            </Modal>

                        </CardBody>
                        }
                        <NotificationSystem ref="notificationSystem"/>
                    </Card>
                </ViewContent>
            </div>
        );
    }
}
function mapStateToProps(state, ownProps) {
    const { loggingIn } = state.authentication;
    const { requesting, pageRequesting } = state.api;
    const { alert, modal, workFlowProcess, entities } = state;
    return {
        loggingIn,
        requesting,
        pageRequesting,
        modal,
        alert,
        workFlowProcess,
        entities
    };
}
export default connect(mapStateToProps)(WorkflowViewContent);



// WEBPACK FOOTER //
// ./src/views/workflow/view-content.js